import http from '../http'
import { Res } from '../type'
import { TencentCreateResource, TencentCreateResourceParams } from '../Models/TencentCreateResource'
import { TencentGetResource, TencentGetResourceParams } from '../Models/TencentGetResource'
import { TencentUploadCredentials } from '../Models/TencentUploadCredentials'
import { TencentPreviewSignParams } from '../Models/TencentPreviewSign'
import { TencentSingedUrlParams } from '../Models/TencentSingedUrl'
import { TencentPreviewURLParams } from '../Models/TencentPreviewURL'
import { TencentTouristSingedUrlParams, VideoCovers, VideoIdParams, VideoUrls } from '../Models/VideoCovers'

// 腾讯对象存储相关功能副本-获取STS临时密钥
export const getTencentUploadCredentials = (): Res<TencentUploadCredentials> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/cos/getCredentials',
    method: 'get',
    loadingShow: '0'
  })
}

// '腾讯对象存储相关功能副本-获取文件预览签名'
export const postTencentPreviewSign = (params: TencentPreviewSignParams): Promise<string> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/cos/getSign',
    method: 'post',
    params
  })
}

// 腾讯对象存储相关功能副本-生成签名URL
export const getTencentSingedUrl = (data: TencentSingedUrlParams): Res<string> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/getURL?id=' + data.id,
    method: 'get',
    loadingShow: '0'
  })
}

// 腾讯视频点播相关功能副本-获取上传签名凭证
export const getTencentVideoSign = (): Res<string> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/vod/getUploadSignature',
    method: 'get',
    loadingShow: '0'
  })
}

// 文件资源相关接口-创建系统资源
export const postTencentCreateResource = (data: TencentCreateResourceParams): Res<TencentCreateResource> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/create',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 文件资源相关接口-系统资源详情
export const getTencentGetResource = (data: TencentGetResourceParams): Promise<TencentGetResource> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/get',
    method: 'get',
    data
  })
}

// 文件资源相关接口-获取文件预览url接口
export const getTencentPreviewURL = (params: TencentPreviewURLParams): Promise<string> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/getURL',
    method: 'get',
    params
  })
}

// 文件资源相关接口-批量获取封面图
export const postVideoCovers = (params: VideoIdParams): Promise<VideoCovers> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/batchCoverURL',
    method: 'post',
    params
  })
}

// 文件资源相关接口-批量获取文件预览链接
export const postVideoUrls = (params: VideoIdParams): Promise<VideoUrls> => {
  return http.request({
    url: '/sands-system/api/v1/system/resource/batchGetURL',
    method: 'post',
    params
  })
}

// 游客 --- 腾讯对象存储相关功能副本-获取STS临时密钥
export const getTencentUploadCredentialsForTourist = (params: TencentTouristSingedUrlParams): Res<TencentUploadCredentials> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/open/cos/getCredentials',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 游客 --- 腾讯视频点播相关功能副本-获取上传签名凭证
export const getTencentVideoSignForTourist = (params: TencentTouristSingedUrlParams): Res<string> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/open/vod/getUploadSignature',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 游客 --- 文件资源相关接口-创建系统资源
export const postTencentCreateResourceForTourist = (data: TencentCreateResourceParams): Res<TencentCreateResource> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/open/create',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 游客 --- 文件资源相关接口-获取文件预览url接口
export const getTencentSingedUrlForTourist = (data: TencentSingedUrlParams): Res<string> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/open/cos/getSignedUrl',
    method: 'post',
    data
  })
}

export const postTextTranslate = (data: { text: string; target: string; bizType: number; bizId: string | number }): Res<{ targetText: string, target: string }> => {
  return http.request({
    url: '/sands-system/api/v1/tencent/textTranslate',
    method: 'post',
    data,
    loadingShow: '0',
    toastShow: '0'
  })
}
